<template>
    <div id="wrapper">
      <Sidebar></Sidebar>
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">

          <Topbar></Topbar>

          <!-- Begin Page Content -->
          <div class="container-fluid">

            <!-- Page Heading -->
            <router-link :to="{ name: 'Home'}" > CRCB Control Panel</router-link> >  
            <router-link :to="{ name: 'Activity_en'}" > 英文版活動剪影 </router-link> >  
            <h1 class="h3 mb-2 mt-2 text-gray-800">英文版活動剪影{{mode}}</h1>

            <Msg :message="message" :is_error="is_error"></Msg>

            <div class="text-center" v-if="loading" >
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>  

            <!-- DataTales Example -->
            <div class="card shadow mb-4"  v-if="!loading">
              <div class="card-header py-3">
                <button type="button" class="btn btn-primary" v-on:click="Post" v-if="!is_edit ">新增</button>
                <button type="button" class="btn btn-primary" v-on:click="Update" v-if="is_edit ">儲存</button>
                <button type="button" class="btn btn-danger" v-on:click="Delete" data-bs-toggle="tooltip" data-bs-placement="top" v-if="is_edit">刪除</button>
              </div>
              <div class="card-body">
                <form>
                    <div class="form-group">
                        <label for="title"><span>*</span>標題</label>
                        <input type="text" class="form-control form-control-user" id="title"  v-model="data.title" >
                        <p class="remind title-p" style="font-size: 0px;">請填寫標題</p>
                    </div>
                    <div class="form-group">
                        <label for="date"><span>*</span>日期</label>
                        <input type="date" class="form-control form-control-user" id="date"  v-model="data.date"  >
                        <p class="remind date-p" style="font-size: 0px;">請填寫日期</p>
                    </div>
                    <UploadFile :name="name" :id="id" :title="title" :src="data.src" :height="data.height" :width="data.width" @update="selfUpdate"></UploadFile>
                    <p class="remind main-photo-p" style="font-size: 0px;">請上傳相簿封面</p>
                    <div class="form-group">
                        <div class="col-12 mb-5 px-0">
                            <label><span>*</span>相片管理</label>
                            <p class="remind photo-p" style="font-size: 0px;">請上傳相片</p>
                            <label class="btn btn-info">
                            <input  style="display:none;" type="file" @change="PreviewImageMulti" accept="image/*"  multiple>
                            <i class="far fa-file-image"></i> 上傳相片
                            </label>
                        </div>

                        <draggable v-model="images" group="images" @start="drag=true" @end="drag=false;UpdateOrder()" :diabled="disabled" class="row">
                            <div class="col-2 item-images" v-for="(item) in images" :key="item.id" >
                            <img  :src="item.src" style="width:100%"/> 
                            <div class="form-group">
                                <label><span>*</span>相片標題</label>
                                <input type="text" class="form-control form-control-user"  v-model="item.caption" >
                            </div>
                            <div class="form-group" v-if="!item.is_upload">
                                <p>Progress: {{item.uploadValue.toFixed()+"%"}}
                                <progress id="progress" :value="item.uploadValue" max="100" style="width:100%"></progress>  </p>
                            </div>
                            <div class="form-group" v-if="item.is_upload">
                                <p><button type="button" class="btn btn-danger btn-sm" v-on:click="deleteImg(item.name)" >刪除</button></p>
                            </div>
                            </div>
                        </draggable>
                    </div>
                    <div class="form-group">
                        <label for="desc"><span>*</span>簡述</label>
                        <textarea class="form-control" id="desc" rows="3" v-model="data.desc" ></textarea>
                        <p class="remind desc-p" style="font-size: 0px;">請輸入簡述</p>
                    </div>
                    
                </form>
              </div>
            </div>

          </div>
          <!-- /.container-fluid -->

        </div>
        <!-- End of Main Content -->

        <Footer></Footer>

      </div>
      <!-- End of Content Wrapper -->
    </div>
</template>

<script>
import {fb, db } from '../firebase'
import Sidebar from './shared/Sidebar'
import Topbar from './shared/Topbar'
import Footer from './shared/Footer'
import Draggable from 'vuedraggable'
export default {
  name: 'ActivityInfo',
  data () {
    return {
      id:this.$route.params.id || db.collection("activity_en").doc().id,
      mode:'',
      is_edit:false,
      name:'activity_en',
      title:'相簿封面',
      data:{
        title:'',
        date:'',
        desc:'',
        src:'',
        height:'',
        width:'',
        images:[],
        order:0
      },
      images:[],
      is_upload:true,
      uploadValue:100,
      disabled:false,
      loading:true,
      message:'',
      is_error:false
    }
  },
  components: {
    Sidebar,Topbar,Footer,Draggable
  },
  mounted () {
    this.Switch();
    this.GetOrder();
  },
  methods: {
    Switch() {
      if ( this.$route.name == 'Activity_enAdd'  ) {
          this.mode = '新增';
      } else {
          this.mode = '編輯';
          this.is_edit = true;
      }
    },
    UpdateOrder() {
      var vm = this;
      this.images.forEach(function(value, index, array){
        value.order = index;
      })
    },
    Get(){
      if ( this.$route.name != 'Activity_enAdd'  ) {
        db.collection("activity_en").doc(this.id).get().then((doc) => {
            if (doc.exists) {
              this.data = doc.data();
              for ( var i = 0 ; i < this.data.images.length ; i++ ) {
                var tmp = {
                    id:       this.data.images[i].id,
                    caption:  this.data.images[i].name,
                    name:     this.data.images[i].name,
                    src:      this.data.images[i].src,
                    thumbnail:this.data.images[i].thumbnail,
                    order:    this.data.images[i].order,
                    uploadValue:100,
                    is_upload:true
                }
                this.images.push(tmp);
              }
          
            } else {
              this.$router.push({name: 'Activity_en'}); 
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
      } 
      
      this.loading = false;
    },
    GetOrder(){
      var vm = this;
      var array = [];
      db.collection("activity_en").get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          var data = {"id": doc.id, "data": doc.data()};
            
            array.push(data);
        });
        array.sort( (d1, d2) => d2.data.order - d1.data.order);
           
        if ( array.length != 0 ) this.data.order = array[0].data.order +1;

        console.log(this.data.order );
        vm.Get()

      });  
       
    },
    Post() {
      
     var check = true;

      if ( this.data.title.length == 0 ) {
        $(".title-p").css("font-size","14px");
        check = false;
      } else $(".title-p").css("font-size","0px");
      
      if ( this.data.date.length == 0 ) {
        $(".date-p").css("font-size","14px");
        check = false;
      } else $(".date-p").css("font-size","0px");
  
      if ( this.data.src.length == 0 ) {
        $(".main-photo-p").css("font-size","14px");
        check = false;
      } else $(".main-photo-p").css("font-size","0px");
      
      if ( this.images.length == 0 ) {
        $(".photo-p").css("font-size","14px");
        check = false;
      } else $(".photo-p").css("font-size","0px");
      
      if ( this.data.desc.length == 0 ) {
        $(".desc-p").css("font-size","14px");
        check = false;
      } else $(".desc-p").css("font-size","0px");

      if (check) {
        this.Beforesend();
        var vm = this;
        //  將圖片資料轉到準備新增的資料
        this.images.forEach(function(value, index, array){

            var item = {
                id:value.id,
                name:value.name,
                src: value.src,
                order: value.order
            }
            vm.data.images.push(item);
        });

        db.collection("activity_en").doc(this.id).set(this.data)
        .then((doc) => {
            alert("新增成功!");
            this.$router.push({name: 'Activity_en'}); 
            this.Aftersend();
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
      }
 
    },
    Update() {
      
      var check = true;

      if ( this.data.title.length == 0 ) {
        $(".title-p").css("font-size","14px");
        check = false;
      } else $(".title-p").css("font-size","0px");
      
      if ( this.data.date.length == 0 ) {
        $(".date-p").css("font-size","14px");
        check = false;
      } else $(".date-p").css("font-size","0px");
  
      if ( this.data.src.length == 0 ) {
        $(".main-photo-p").css("font-size","14px");
        check = false;
      } else $(".main-photo-p").css("font-size","0px");
      
      if ( this.images.length == 0 ) {
        $(".photo-p").css("font-size","14px");
        check = false;
      } else $(".photo-p").css("font-size","0px");
      
      if ( this.data.desc.length == 0 ) {
        $(".desc-p").css("font-size","14px");
        check = false;
      } else $(".desc-p").css("font-size","0px");

      if (check) {
        this.Beforesend();
         var vm = this;
        //  將圖片資料轉到準備新增的資料
        this.data.images = [];
        this.images.forEach(function(value, index, array){

            var item = {
                id:value.id,
                name:value.name,
                src: value.src,
                order: value.order
            }
            vm.data.images.push(item);
        });

        db.collection("activity_en").doc(this.id).update(this.data)
          .then(() => {
              alert("儲存成功!");
              this.Aftersend();
              this.$router.push({name: 'Activity_en'}); 
          }).catch((error) => {
              console.log("Error getting document:", error);
          });
      }
    
    },
    Delete() {
      if ( confirm("確定要刪除?") ) {
        this.Beforesend();
        db.collection("activity_en").doc(this.id).delete()
        .then(() => {


          const storageRef = fb.storage().ref('activity_en/'+ this.id);
          storageRef.listAll().then((listResults) => {
            const promises = listResults.items.map((item) => {
              return item.delete();
            });
            Promise.all(promises);

            alert("刪除成功!");
            this.Aftersend();
            this.$router.push({name: 'Activity_en'}); 
          });
          
           
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
      }
    },
    PreviewImageMulti(event) {

      var index = this.images.length;
      for (var i = 0 ; i < event.target.files.length ; i++ ) {

        index = index + 1;
        var tmp = {};
        tmp.imageData =  event.target.files[i];
        tmp.id = index ;
        tmp.order = index ;
        tmp.uploadValue = 0;
        tmp.is_upload = false;
        tmp.caption = event.target.files[i].name;
        //  tmp.name = event.target.files[i].name ;
        tmp.name = encodeURIComponent(event.target.files[i].name).replace(/['()]/g, escape);
        tmp.src = URL.createObjectURL(event.target.files[i]);
        
        this.images.push(tmp);
        this.onUploadMulti(tmp);
      }
    },
    onUploadMulti(tmp){

      this.picture=null;

      const storageRef= fb.storage().ref('activity_en/' + this.id + '/'  +tmp.name).put(tmp.imageData);

      storageRef.on('state_changed',
      snapshot=>{
        this.images.find(x => x.id === tmp.id).uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
      }, 
      error => {
        console.log(error.message)
      }, 
      () => {
        this.images.find(x => x.id === tmp.id).uploadValue=100;
        
        storageRef.snapshot.ref.getDownloadURL().then((url)=>{
          this.images.find(x => x.id === tmp.id).src =url;
          this.images.find(x => x.id === tmp.id).is_upload = true;
          console.log('success');
        });
        
      
      }
      );
    },
    deleteImg(name) {
      
      if ( confirm("確定要刪除" + name + "?") ) {
        this.Beforesend();
        const storageRef= fb.storage().ref('activity_en/'+ this.id  + '/' +name).delete().then(() => {
          // File deleted successfully
          var index = this.images.findIndex(x => x.name ===name);
          this.images.splice(index,1);
          alert("刪除成功");
          this.Aftersend();
        }).catch((error) => {
          // Uh-oh, an error occurred!
          var index = this.images.findIndex(x => x.name ===name);
          this.images.splice(index,1);
          this.Aftersend();
        });
      }

    
    },
    selfUpdate(val) {
      this.data.src = val.src;
      this.data.width = val.width;
      this.data.height = val.height;
      this.data.pic_name = val.pic_name;
    }
  }
}
</script>

<style scoped>
label{
  cursor: pointer;
}
label span, .remind{
  color:#BE0000
}
</style>


// WEBPACK FOOTER //
// src/components/ActivityInfoEN.vue